export class PersonaReniec {
    dcAddDepUbigCode: string;
    dcAddDistUbigCode: string;
    dcAddProvUbigCode: string;
    dcAddress: string;
    dcBornDate: string;
    dcDocument: string;
    dcExpeditionDate: string;
    dcFirstName: string;
    dcLastName1: string;
    dcLastName2: string;
    dcMotherName: string;
    dcGenter: string;
    dcAddressBlock: string;
    dcAddressBlockPrefix: string;
    dcAddressBlockPrefixDes: string;
    dcAddressEt: string;
    dcAddressIntPrefix: string;
    dcAddressIntPrefixDes: string;
    dcAddressInterior: string;
    dcAddressLt: string;
    dcAddressMz: string;
    dcAddressNumber: string;
    dcAddressUrb: string;
    dcAddressUrbPrefix: string;
    dcAddressUrbPrefixDes: string;
    dcDepartmentAddress: string;
    dcDistritAddress: string;
    dcAddPrefixDes: string;

}

